import i18next from 'i18next';
import * as yup from 'yup';

export const schema = yup.object().shape({
  building: yup.object().required(i18next.t('validation.common.required')),
  name: yup.string().required(i18next.t('validation.common.required')),
});
